<template>
  <v-row no-gutters class="py-3">
    <v-col cols="12" md="9">
      <!-- <div>
        <span class="font-weight-bold">Accionante:&nbsp;</span>
        <span class="text-capitalize">{{ tutela }}</span>
      </div> -->

      <div v-for="(item, index) in tutela.accionados" :key="index">
        <span class="font-weight-bold">Accionados:&nbsp;</span>
        <span class="text-capitalize">{{ item.nombre || "--" }}</span>
      </div>

      <div class="my-1"     v-if="tutela.derechos">
        <span class="font-weight-bold">Derechos:&nbsp;</span>
        <v-chip
          class="text-capitalize primary lighthen-2"
          x-small
          v-for="(item, index) in tutela.derechos"
          :key="index"
        >
          {{ item.nombre }}
        </v-chip>
      </div>
    </v-col>
    <v-col cols="12" md="3">
      <div>
        <span class="font-weight-bold">Fecha Creación:&nbsp;</span>
        <span class="text-capitalize">{{ tutela.fechaTutela }}</span>
      </div>
      <div>
        <span class="font-weight-bold">Departamento:&nbsp;</span>
        <span class="text-capitalize">{{ tutela.departamento }}</span>
      </div>

      <div>
        <span class="font-weight-bold">Municipio:&nbsp;</span>
        <span class="text-capitalize">{{ tutela.municipio }}</span>
      </div>
      
    </v-col>
    
  </v-row>
</template>

<script>
export default {
  props: {
    tutela: {
      type: Object,
      required: true,
    },
  },
};
</script>
  
